import {
    type ExistingGoalsBadge,
    type ExistingGoalsBadgesWidgetProps,
} from '@fruitful/types';
import React from 'react';
import {
    BodyLargeRegular,
    BodySmallRegular,
    CircleDollarSignIcon,
    FontFamilyName,
    Icon,
    type IconType,
    TreePalmIcon,
    XStack,
    YStack,
} from 'smoothie';

import { CHAT_ASSISTANT_PADDING_HORIZONTAL } from '../layout/ChatLayout';

const ICON_MAP: Record<string, IconType> = {
    'emergency-fund': CircleDollarSignIcon,
    retirement: TreePalmIcon,
};

const GoalBadgePill = ({ goal }: { goal: ExistingGoalsBadge }) => {
    const IconComponent = ICON_MAP[goal.icon];

    return (
        <XStack
            backgroundColor="rgba(255, 255, 255, 0.50)"
            borderRadius={100}
            paddingVertical={8}
            paddingHorizontal={16}
            alignItems="center"
            gap={8}
        >
            {IconComponent != null && (
                <Icon icon={IconComponent} size={18} color="$black" />
            )}
            <BodySmallRegular color="$black">{goal.label}</BodySmallRegular>
        </XStack>
    );
};

export const ExistingGoalsBadgesWidget = ({
    title,
    goals,
}: ExistingGoalsBadgesWidgetProps) => {
    return (
        <YStack paddingHorizontal={CHAT_ASSISTANT_PADDING_HORIZONTAL} gap={12}>
            <BodyLargeRegular
                color="$black"
                style={{ fontFamily: FontFamilyName.SourceSerifRegular }}
            >
                {title}
            </BodyLargeRegular>
            <XStack flexWrap="wrap" gap={10}>
                {goals.map((goal) => (
                    <GoalBadgePill key={goal.icon} goal={goal} />
                ))}
            </XStack>
        </YStack>
    );
};
